<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />
        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-cubes mr-2" />Inventory Pending
            </h5>
            <hr />
            <b-row>
                <b-col md="8">
                    <div class="d-flex">
                        <b-input-group>
                            <b-input-group-prepend>
                                <b-button
                                    variant="dark"
                                    @click="showModalFilter"
                                >
                                    <i class="fa fa-search mr-2" />Filter...
                                </b-button>
                            </b-input-group-prepend>
                            <b-form-input
                                v-model="filter.noFaktur"
                                maxlength="50"
                                placeholder="Cari No. Faktur..."
                                @keydown.enter="changeFilter()"
                            />
                        </b-input-group>
                        <b-input-group class="ml-2">
                            <b-form-input
                                v-model="filter.imeiSn"
                                maxlength="50"
                                placeholder="Cari No. Imei..."
                                @keydown.enter="changeFilter()"
                            />
                            <b-input-group-append>
                                <b-button
                                    variant="primary"
                                    @click="changeFilter()"
                                    >Cari</b-button
                                >
                            </b-input-group-append>
                        </b-input-group>
                        <b-button
                            class="ml-2"
                            variant="danger"
                            @click="resetFilter"
                        >
                            Reset
                        </b-button>
                    </div>
                </b-col>

                <b-col md="4" class="text-right">
                    <b-dropdown variant="success" id="dropdown-download-excel">
                        <template #button-content>
                            <i class="fa fa-download mr-2"></i> Download Excel
                        </template>
                        <b-dropdown-item-button @click="downloadExcelStock">Stock Barang</b-dropdown-item-button>  
                    </b-dropdown>
                </b-col>
            </b-row>
            <template v-if="initTable">
                <b-table
                    bordered
                    hover
                    show-empty
                    no-local-sorting
                    :busy="isBusy"
                    :items="items"
                    :fields="fields"
                    @sort-changed="onSortChanged"
                    responsive
                    class="my-3"
                >
                    <template v-slot:empty>
                        Tidak ada data inventory.
                    </template>
                    <template v-slot:cell(item)="row">
                        {{ row.item.type }}
                        <span v-if="row.item.item_year != null"
                            >({{ row.item.item_year }})</span
                        >
                        <div class="small">
                            {{ row.item.kind }} - {{ row.item.brand }} -
                            {{ row.item.color }}<br />
                            NF
                            <strong
                                style="cursor:pointer;"
                                @click="copyToClipboard(row.item.no_faktur_pgi)"
                                >{{ row.item.no_faktur_pgi || "-" }}</strong
                            >
                            <i
                                style="cursor:pointer;"
                                @click="copyToClipboard(row.item.no_faktur_pgi)"
                                class="fa fa-fw fa-copy"
                            /><br />
                            IMEI
                            <strong
                                style="cursor:pointer;"
                                @click="copyToClipboard(row.item.imei_sn)"
                                >{{ row.item.imei_sn || "-" }}
                            </strong>
                            <i
                                style="cursor:pointer;"
                                @click="copyToClipboard(row.item.imei_sn)"
                                class="fa fa-fw fa-copy"
                            />
                        </div>
                    </template>
                    <template v-slot:cell(price)="row">
                        Rp.
                        {{
                            $helper.formatThousand(
                                row.item.final_price_after_segment
                            )
                        }}
                        <div class="small">
                            Harga Dasar: Rp.
                            {{ $helper.formatThousand(row.item.base_price)
                            }}<br />
                            Kloter {{ $helper.parseDate(row.item.created)
                            }}<br />
                            {{ row.item.source || "-" }}
                        </div>
                    </template>
                    <template v-slot:cell(detail)="row">
                        Grade <strong>{{ row.item.grade || "-" }}</strong>
                        <div class="small">
                            <div
                                v-if="
                                    row.item.item_spec_id == 2 &&
                                        row.item.is_handphone == 0
                                "
                            >
                                Spek <strong>ORI</strong><br />
                            </div>
                            <div v-else>
                                Spek <strong>{{ row.item.spec }}</strong
                                ><br />
                            </div>
                            {{
                                row.item.is_batangan == true
                                    ? "Batangan"
                                    : "Lengkap"
                            }}<br />
                            {{
                                row.item.warehouse == null
                                    ? "-"
                                    : "Gudang " + row.item.warehouse
                            }}
                            - {{ row.item.office }}
                        </div>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge variant="warning">{{
                            status[row.item.status]
                        }}</b-badge>
                    </template>
                    <template v-slot:cell(action)="row">
                        <b-button
                            size="sm"
                            variant="primary"
                            v-b-tooltip.hover.top
                            title="Detail"
                            @click="showDetail(row.item)"
                        >
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </template>
                    <template #table-busy>
                        <div class="d-flex justify-content-center">
                            <b-spinner label="Loading..." />
                        </div>
                    </template>
                </b-table>
                <PageSizer
                    :totalRows="totalRows"
                    :page="currentPage"
                    :options="options"
                    @limit-change="onLimitChange"
                    @page-change="onPageChange"
                />
            </template>
            <div class="d-flex justify-content-center mt-3">
                <b-spinner
                    v-if="isLoadingTable && !initTable"
                    label="Loading..."
                />
            </div>
        </b-card>

        <b-modal
            id="m-detail"
            title="Detail Inventory"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <DetailInventory :id="activeId" />
        </b-modal>

        <b-modal
            id="m-filter"
            title="Filter Pencarian"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
        >
            <strong>DATA BARANG</strong>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Nama Barang">
                        <b-form-input
                            v-model="filter.name"
                            maxlength="50"
                            placeholder="Cari Nama Barang..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Divisi">
                        <multiselect
                            v-model="filter.division"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optDivision"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Jenis">
                        <multiselect
                            v-model="filter.kind"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optKind"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <b-form-group label="Merk">
                        <multiselect
                            v-model="filter.brand"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optBrand"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Tahun / Generasi Barang">
                        <b-form-input
                            v-model="filter.itemYear"
                            maxlength="4"
                            placeholder="Cari Tahun / Generasi Barang..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="No. Faktur PGI">
                        <b-form-input
                            v-model="filter.noFaktur"
                            maxlength="50"
                            placeholder="Cari No. Faktur PGI..."
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <b-form-group label="IMEI / SN">
                        <b-form-input
                            v-model="filter.imeiSn"
                            maxlength="100"
                            placeholder="Cari IMEI / SN..."
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <hr />
            <strong>PENILAIAN BARANG</strong>
            <b-row class="mt-1">
                <b-col md="6">
                    <b-form-group label="Grade PGI">
                        <multiselect
                            :multiple="true"
                            :close-on-select="false"
                            v-model="filter.grade"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optGrade"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Kelengkapan PGI">
                        <b-form-select
                            v-model="filter.isBatangan"
                            :options="optIsBatangan"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <b-form-group label="Spek PGI">
                        <multiselect
                            v-model="filter.spec"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            :options="optSpec"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <hr />
            <strong>KLOTER PENGIRIMAN</strong>
            <b-row class="mt-1">
                <b-col md="4">
                    <b-form-group label="Dari">
                        <b-form-input type="date" v-model="filter.from" />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Sampai">
                        <b-form-input type="date" v-model="filter.to" />
                    </b-form-group>
                </b-col>
            </b-row>
            <div class="mt-4 text-right">
                <b-button variant="danger" @click="resetFilter">
                    Reset Filter
                </b-button>
                <b-button variant="primary" class="ml-3" @click="getItems()">
                    Cari
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-download-report" centered no-close-on-backdrop no-close-on-esc hide-footer hide-header-close
            ref="downloadModal">
            <template #modal-title>
                {{ modalTitleDownload }}
                <button type="button" class="close" aria-label="Close" :disabled="fetchReportStatus == 0"
                    @click="$refs.downloadModal.hide()" style="position: absolute; top: 0.5rem; right: 1rem;">
                    <b-spinner small v-if="fetchReportStatus == 0" />
                    <span v-else aria-hidden="true">&times;</span>
                </button>
            </template>
            <div v-if="fetchReportStatus == 0">Menyiapkan laporan, mohon menunggu...</div>
            <div v-else-if="fetchReportStatus == -1">Gagal mendapatkan laporan, mohon coba kembali!</div>
            <div v-else>
                Silahkan tekan tombol dibawah ini untuk download laporan.
                <div class="mt-2">
                    <a :href="reportPath" download>
                        <b-button variant="success">
                            <i class="fa fa-download mr-2" />Download
                        </b-button>
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import DetailInventory from "./DetailInventory.vue";
import LoadingOverlay from "./LoadingOverlay.vue";

export default {
    components: {
        DetailInventory,
        LoadingOverlay
    },
    data() {
        return {
            initStatus: 0,
            initTable: 0,
            isLoadingTable: false,
            isBusy: true,

            fetchReportStatus: 0,
            reportPath: "",

            activeId: 0,

            filter: {
                name: "",
                division: null,
                kind: null,
                brand: null,
                itemYear: "",
                spec: null,
                noFaktur: "",
                imeiSn: "",
                grade: [],
                isBatangan: -1,
                from: null,
                to: null
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                { key: "item", label: "Barang", sortable: true },
                { key: "price", label: "Harga Jual", sortable: true },
                { key: "detail", label: "Detail", sortable: true },
                { key: "status", label: "Status", sortable: true },
                { key: "action", label: "Aksi" }
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optKind: [],
            optDivision: [{ id: 1, name: "HP" }, { id: 2, name: "NON HP" }],
            optBrand: [],
            optSpec: [],

            optGrade: [
                { id: "S", name: "S" },
                { id: "A", name: "A" },
                { id: "B", name: "B" },
                { id: "C", name: "C" },
                { id: "D", name: "D" },
                { id: "E", name: "E" },
                { id: "X", name: "X" }
            ],
            optIsBatangan: [
                { value: -1, text: "Semua" },
                { value: 1, text: "Batangan" },
                { value: 0, text: "Lengkap" }
            ],

            status: {
                1: "PENDING"
            }
        };
    },
    methods: {
        init() {
            this.initStatus = 0;

            let getSpecs = this.$axios
                .get("master/spec/selection")
                .then(res => {
                    this.optSpec = res.data.data;
                });

            let getDivision = this.$axios
                .get("division/get-all-filtered")
                .then(res => {
                    this.optDivision = this.optDivision.filter(division => {
                        return res.data.data.some(
                            item => item.id === division.id
                        );
                    });
                });

            Promise.all([getSpecs, getDivision])
                .then(() => {
                    this.initStatus = 1;
                })
                .catch(() => {
                    this.initStatus = -1;
                });
        },

        showDetail(item) {
            this.activeId = item.id;
            this.$bvModal.show("m-detail");
        },

        async changeFilter() {
            this.isLoadingTable = true;

            await this.getItems();

            this.isLoadingTable = false;
        },

        getItems(page = 1) {
            this.$bvModal.hide("m-filter");
            this.isBusy = true;
            this.items = [];
            this.initTable = 1;

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage,
                true
            );
            param += this.processFilter();

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy;
                param += "&sortDesc=" + this.sortDesc;
            }

            return this.$axios
                .get("inventory/pending" + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                    sessionStorage.setItem(
                        "listInventoryPendingFilter",
                        JSON.stringify(this.filter)
                    );
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        downloadExcelStock() {

            this.fetchReportStatus = 0
            this.modalTitleDownload = "Download Excel Stock Pending";
            this.$bvModal.show("m-download-report")

            let param = this.processFilter()

            this.$axios.get("inventory/excel-stock-pending?" + param).then(res => {

                this.reportPath = res.data.data.path
                this.fetchReportStatus = 1

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.fetchReportStatus = -1
                })
                .finally(() => this.isSubmitting = false)

        },


        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        resetFilter() {
            this.filter = {
                name: "",
                division: null,
                kind: null,
                brand: null,
                itemYear: "",
                spec: null,
                noFaktur: "",
                imeiSn: "",
                grade: [],
                isBatangan: -1,
                from: null,
                to: null
            };

            this.getItems();
        },

        processFilter() {
            let param = "";

            if (!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name;
            }

            if (this.filter.division != null) {
                param += "&filterDivision=" + this.filter.division.id;
            }

            if (this.filter.kind != null) {
                param += "&filterKind=" + this.filter.kind.id;
            }

            if (this.filter.brand != null) {
                param += "&filterBrand=" + this.filter.brand.id;
            }

            if (
                !this.$helper.isBlank(this.filter.itemYear) &&
                !isNaN(this.filter.itemYear)
            ) {
                param += "&filterItemYear=" + Number(this.filter.itemYear);
            }

            if (!this.$helper.isBlank(this.filter.noFaktur)) {
                param += "&filterNoFaktur=" + this.filter.noFaktur;
            }

            if (!this.$helper.isBlank(this.filter.imeiSn)) {
                param += "&filterImeiSn=" + this.filter.imeiSn;
            }

            if (this.filter.grade.length != 0) {
                param +=
                    "&filterGrade=" + this.filter.grade.map(it => it.id).join();
            }

            if (this.filter.isBatangan != -1) {
                param += "&filterIsBatangan=" + this.filter.isBatangan;
            }

            if (this.filter.spec != null) {
                param += "&filterSpec=" + this.filter.spec.id;
            }

            if (this.filter.from != null) {
                param += "&filterFrom=" + this.filter.from;
            }

            if (this.filter.to != null) {
                param += "&filterTo=" + this.filter.to;
            }

            return param;
        },

        showModalFilter() {
            this.$bvModal.show("m-filter");
        },

        copyToClipboard(text) {
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    this.$helper.toastSuccess(this, "Text berhasil disalin!");
                })
                .catch(() =>
                    this.$helper.toastError(this, "Text gagal disalin!")
                );
        }
    },
    watch: {
        "filter.kind": function(newVal) {
            this.filter.brand = null;
            this.optBrand = [];

            if (newVal != null) {
                this.$axios
                    .get("master/brands/" + this.filter.kind.id)
                    .then(res => {
                        this.optBrand = res.data.data;
                    });
            }
        },
        "filter.division": function(newVal) {
            this.filter.kind = null;
            this.optKind = [];
            this.filter.brand = null;
            this.optBrand = [];

            if (newVal != null) {
                const params = {
                    division: this.filter.division.id
                };

                this.$axios.get("master/kinds", { params }).then(res => {
                    this.optKind = res.data.data;
                });
            }
        }
    },
    created() {
        this.init();
    }
};
</script>

<style scoped>
p {
    margin: 0;
}
</style>
